import type { App } from 'vue'
import ElementPlus from 'element-plus'

// 需要全局引入一些组件，如ElScrollbar，不然一些下拉项样式有问题
// import { ElLoading, ElScrollbar } from 'element-plus'

// const plugins = [ElLoading]

// const components = [ElScrollbar]

export const setupElementPlus = (app: App<Element>) => {
  // 全局注册 Element Plus
  app.use(ElementPlus)

  // plugins.forEach((plugin) => {
  //   console.log('app use plugin ', plugin)
  //   app.use(plugin)
  // })

  // 为了开发环境启动更快，一次性引入所有样式
  if (import.meta.env.VITE_USE_ALL_ELEMENT_PLUS_STYLE === 'true') {
    import('element-plus/dist/index.css')
  }

  // components.forEach((component) => {
  //   app.component(component.name!, component)
  // })
}
